<!--
    @负责人: libaiiq
    @创建时间: 2018-09-05
    @版本:v1.0.22
    @描述: 资源模型管理
    -->
<template>
  <div class="resourceManage__content">
    <g-back :history="history"></g-back>
    <div class="resourceManage__mb10">
      <el-button type="primary" @click="e_edit" v-g-rac="gRac('resourceMangae@edit')">{{ $t('common.edit') }}</el-button>
      <el-button type="primary" @click="e_add(null)" v-g-rac="gRac('resourceMangae@add')">{{ $t('resourceModel.addProperty') }}</el-button>
      <el-button type="primary" @click="e_delete" v-g-rac="gRac('resourceMangae@deleteModel')">{{ $t('common.delete') }}</el-button>
    </div>
    <div class="resourceManage__table">
      <el-table
        :data="tData"
        border
        style="width: 100%">
        <el-table-column
          prop="property"
          :label="$t('resourceModel.table.property')"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="name"
          :label="$t('resourceModel.table.name')">
        </el-table-column>
        <el-table-column
          prop="type"
          :label="$t('resourceModel.table.type')"
          :formatter="formatterType">
        </el-table-column>
        <el-table-column
          prop="value"
          :label="$t('resourceModel.table.value')"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="require"
          :label="$t('resourceModel.table.require')"
          :formatter="formatterBoolean">
        </el-table-column>
        <el-table-column
          prop="readOnly"
          :label="$t('resourceModel.table.readOnly')"
          :formatter="formatterBoolean">
        </el-table-column>
        <el-table-column
          prop="only"
          :label="$t('resourceModel.table.only')"
          :formatter="formatterBoolean">
        </el-table-column>
        <el-table-column
          prop="display"
          :label="$t('resourceModel.table.display')"
          :formatter="formatterBoolean">
        </el-table-column>
        <el-table-column
          prop="search"
          :label="$t('resourceModel.table.search')"
          :formatter="formatterBoolean">
        </el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.handle')">
          <template slot-scope="scope">
            <el-button type="text" v-show="!scope.row.readOnly" @click="e_add(scope.row)" size="small">{{ $t('common.edit') }}</el-button>
            <el-button type="text" v-show="!scope.row.readOnly" @click="e_deleteItem(scope.row)" size="small">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <dialog-form
      key="resourceEdit"
      :title="$t('resourceModel.edit')" 
      :size="2" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="isConfirmAmend">
    </dialog-form>
    <dialog-form
      key="propertyAdd"
      :title="dialogTitle" 
      :size="3" 
      :label-size="2" 
      :visible.sync="dialogPropertyShow" 
      :model="dialogPropertyModel"
      :input-data="dialogDataForProperty"
      :rules="dialogPropertyFormRule"
      :confirm-fun="isConfirmAdd">
    </dialog-form>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'
  export default {
    mixins: [rac, dic, table],
    data () {
      const that = this
      return {
        history: [],
        propertyList: {
          require: that.$t('resourceModel.require'),
          only: that.$t('resourceModel.only'),
          readOnly: that.$t('resourceModel.readOnly'),
          encrypt: that.$t('resourceModel.encrypt'),
          sysDic: that.$t('resourceModel.sysDic'),
          search: that.$t('resourceModel.forSearch')
        },
        select: {},
        isAmend: false,
        typeList: {},
        modelList: {},
        resourceName: '',
        resourceData: {},
        selectId: null,
        tableControl: [
          {
            label: that.$t('common.edit'),
            callback: that.e_update
          }, {
            label: that.$t('common.delete'),
            callback: that.e_delete
          }
        ],
        booleanList: {
          true: '是',
          false: '否'
        },
        tData: [],
        dialogFormShow: false,
        dialogData: [],
        dialogFormRule: {},
        dialogModel: {},
        dialogTitle: '',
        dialogPropertyShow: false,
        dialogDataForProperty: [],
        dialogPropertyModel: {},
        dialogPropertyFormRule: {}
      }
    },
    methods: {
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('resourceModel.id'),
            key: 'flagId',
            disabled: true
          },
          {
            label: this.$t('resourceModel.resourceName'),
            key: 'resourceName'
          },
          {
            label: this.$t('resourceModel.resourceType'),
            key: 'resourceType',
            type: 'select',
            select: this.modelList
          },
          {
            label: this.$t('resourceModel.describe'),
            key: 'describe',
            type: 'textarea'
          } ]
        this.dialogDataForProperty = [
          {
            label: this.$t('resourceModel.id'),
            key: 'property'
          },
          {
            label: this.$t('resourceModel.name'),
            key: 'name'
          },
          {
            label: this.$t('resourceModel.type'),
            key: 'type',
            type: 'select',
            select: this.typeList
          },
          {
            label: this.$t('resourceModel.display'),
            key: 'display',
            type: 'select',
            select: this.booleanList
          },
          {
            label: this.$t('resourceModel.value'),
            key: 'value'
          },
          {
            label: this.$t('resourceModel.property'),
            key: 'properties',
            type: 'checkboxGroup',
            select: this.propertyList
          } ]
        this.dialogFormRule = {
          flagId: [{ ...validateConfig.common.notEmpty }],
          resourceName: [{ ...validateConfig.common.notEmpty }],
          resourceType: [{ ...validateConfig.common.notEmpty }]
        }
        this.dialogPropertyFormRule = {
          property: [{ ...validateConfig.common.notEmpty }],
          name: [{ ...validateConfig.common.notEmpty }],
          type: [{ ...validateConfig.common.notEmpty }],
          display: [{ ...validateConfig.common.notEmpty }]
        }
      },
      search () {
        const data = {
          resourceType: this.$route.query.resourceType,
          flagId: this.$route.query.flagId,
          currentPage: 1,
          perPageCount: 1000
        }
        resourceModelBiz.getProperty(data).then((d) => {
          this.tData = d.dataList
        }).catch((err) => {
          console.error(err)
        })
      },
      e_init () {
        this.resourceName = decodeURI(this.$route.query.resourceName)
        this.history = []
        this.history.push({ name: this.resourceName, path: '/home/resourceModel' })
        resourceModelBiz.getResource({resourceName: this.resourceName}).then((d) => {
          this.resourceData = d[0]
        })
        setTimeout(() => {
          this.search()
        }, 200)
      },
      async waitVauleTypeList () {
        await this.dGetDictionaryByCode('vauleType')
        this.typeList = { ...this.dDictionary.vauleType }
        this.setDialogData()
      },
      async waitModelList () {
        await this.dGetDictionaryByCode('resourcemodel')
        this.modelList = { ...this.dDictionary.resourcemodel }
      },
      formatterType (row, column, cellValue, index) {
        return this.typeList[cellValue]
      },
      formatterBoolean (row, column, cellValue, index) {
        return this.booleanList[cellValue]
      },
      e_delete () {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          resourceModelBiz.deleteResource({ flagId: this.$route.query.flagId }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.$router.push({ name: 'resourceModel' })
            }, 500)
          })
        }).catch(() => {})
      },
      e_edit () {
        this.dialogModel = {
          resourceName: this.resourceData.resourceName,
          resourceType: this.resourceData.resourceType,
          describe: this.resourceData.describe,
          flagId: this.$route.query.flagId
        }
        this.dialogFormShow = true
      },
      e_add (rowData) {
        this.isAmend = rowData !== null
        this.dialogPropertyModel = {
          properties: [],
          name: '',
          type: '',
          display: '',
          value: '',
          property: ''
        }
        if (rowData !== null) {
          Object.keys(this.propertyList).forEach((item) => {
            if (rowData[item]) {
              this.dialogPropertyModel.properties.push(this.propertyList[item])
            }
          })
          Object.keys(this.dialogPropertyModel).forEach((item) => {
            if (rowData[item] !== undefined) {
              this.dialogPropertyModel[item] = String(rowData[item])
            }
          })
          this.selectId = rowData.id
        }
        this.dialogTitle = rowData !== null ? this.$t('resourceModel.editProperty') : this.$t('resourceModel.addProperty')
        this.dialogPropertyShow = true
      },
      e_deleteItem (rowData) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          resourceModelBiz.deleteProperty({ id: rowData.id }).then(() => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.search()
            }, 500)
          })
        }).catch(() => {})
      },
      isConfirmAdd () {
        let add = {
          flagId: this.$route.query.flagId,
          name: this.dialogPropertyModel.name,
          resourceType: this.resourceData.resourceType,
          property: this.dialogPropertyModel.property,
          type: this.dialogPropertyModel.type,
          value: this.dialogPropertyModel.value,
          display: this.dialogPropertyModel.display === 'true'
        }
        Object.keys(this.propertyList).forEach((item) => {
          this.$set(add, item, this.dialogPropertyModel.properties.indexOf(this.propertyList[item]) !== -1)
        })
        if (this.isAmend) {
          add.id = this.selectId
          resourceModelBiz.updateProperty(add).then((d) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogPropertyShow = false
              this.search()
            }, 500)
          })
        } else {
          resourceModelBiz.saveProperty(add).then((d) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogPropertyShow = false
              this.search()
            }, 500)
          })
        }
      },
      isConfirmAmend () {
        resourceModelBiz.updateResource(this.dialogModel).then(() => {
          this.dialogFormShow = false
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            this.$router.push({ name: 'resourceModel' })
          }, 1000)
        })
      }
    },
    components: {
      dialogForm
    },
    mounted () {
      this.e_init()
      this.waitModelList()
      this.waitVauleTypeList()
    },
    watch: {
      $route (newV, oldV) {
        if (oldV.name === 'resourceModel' && newV.name === 'resourceManage') {
          this.e_init()
          this.search()
        }
      }
    }
  }
</script>

<style scoped>
  .resourceManage__mb10 {
    margin-bottom: 10px;
  }
  .dataDicProperty .data-dic-label {
    margin-right: 10px;
    width: 90px;
    text-align: right;
    display: inline-block;
  }
  .dataDicProperty .data-dic-select {
    margin-right: 5px;
    width: 42px;
    text-align: left;
    display: inline-block;
  }
</style>